import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { editorOptions } from 'src/app/constants/editor-options';
import { environment } from 'src/environments/environment';
import { IOrganisationEditConfig } from 'src/interfaces/organisation-edit-config';
import { IOrganisation } from 'src/app/interfaces/organisation';
import { CarouselImageDataSource } from 'src/modules/carousel-image/services/carousel-image-data-source';
import { Subscription as RxSubscription } from 'rxjs';

@Component({
    selector: 'organisation-edit-dialog',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class OrganisationsEdit implements OnInit, OnDestroy {
  public leisureUrl = environment.leisureUrl;

  public loading = false;

  public form: FormGroup;
  public editorOptions = editorOptions;
  public Organisation: IOrganisation;
  public CarouselImageDataSource: CarouselImageDataSource;

  private Subscriptions: RxSubscription[] = [];

  constructor(
    protected dialog: MatDialog,
    protected dialogRef: MatDialogRef<OrganisationsEdit>,
    @Inject(MAT_DIALOG_DATA) private config: IOrganisationEditConfig
  ) {}

  ngOnInit() {
    this.Organisation = this.config.Organisation;
    this.CarouselImageDataSource = this.config.CarouselImageDataSource;

    const Organisation = this.config.Organisation;

    this.form = new FormBuilder().group({
      description: [null, [Validators.required]],
      offer_label: [null, [Validators.required]],
      offer: [null],
      offer_terms: [null],
    });

    !!Organisation &&
      Object.keys(Organisation).forEach((name) => {
        if (name === 'extraInfo') {
          Object.keys(Organisation['extraInfo']).forEach((extraInfoName) => {
            !!this.form.controls[extraInfoName] &&
              this.form.controls[extraInfoName].patchValue(
                Organisation['extraInfo'][extraInfoName]
              );
          });
        }
        !!this.form.controls[name] &&
          this.form.controls[name].patchValue(Organisation[name]);
      });
  }

  onSubmit() {
    this.form.disable();

    const { Organisation } = this.config;
    const { id, title, product_id } = Organisation;
    const form = this.form.getRawValue();
    const description = form.description.replace(/<p><br><\/p>/g, '');

    const _Organisation = {
      id,
      product_id,
      title,
      ...form,
      description,
    };

    return this.config.OrganisationDataSource.save(_Organisation).then(
      (organisationId) => this.dialogRef.close(organisationId),
      () => this.form.enable()
    );
  }

  ngOnDestroy() {
    this.Subscriptions.forEach((Subscription) => Subscription.unsubscribe());
  }
}
